<template>
  <div class="memorabiliaBox" style="width: 95%; margin: auto">
    <van-steps
      direction="vertical"
      active-color="#AB0000"
      :active="groups.length"
    >
      <van-step
        v-for="group in groups"
        :key="group.year"
        class="contont"
        :style="group.image ? { backgroundImage: 'url(' + group.image + ')' } : {}"
      >
        <div v-if="!group.image" class="year-label">{{ group.year }}</div>
        <div class="littleTip" v-for="item in group.items" :key="item.id">
          <div class="timeMsg">{{ item.timeText }}</div>
          <div class="contentMsg">
            <div class="contentText">{{ item.text }}</div>
          </div>
        </div>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
import req from "@/utils/index";
import localMemorabilia from "./memorabiliaLocal";

const localYearImages = {
  2023: require("./guanyukuangzhen/2023.png"),
  2024: require("./guanyukuangzhen/2024.png"),
  2025: require("./guanyukuangzhen/2025.png"),
  2026: require("./guanyukuangzhen/2026.png"),
};

export default {
  data() {
    return {
      groups: [],
    };
  },
  created() {
    // 先展示本地兜底，后台有数据则完全以后台为准
    this.groups = this.buildGroups(this.localItems());
    this.loadFromCms();
  },
  methods: {
    decodeEntities(text) {
      return String(text || "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#39;|&apos;/gi, "'")
        .replace(/&ldquo;/gi, "\u201c")
        .replace(/&rdquo;/gi, "\u201d")
        .replace(/&lsquo;/gi, "\u2018")
        .replace(/&rsquo;/gi, "\u2019")
        .replace(/&mdash;/gi, "\u2014")
        .replace(/&ndash;/gi, "\u2013")
        .replace(/&hellip;/gi, "\u2026")
        .replace(/&#(\d+);/g, (_, code) => {
          const n = Number(code);
          return n > 0 && n < 0x110000 ? String.fromCodePoint(n) : "";
        })
        .replace(/&#x([0-9a-f]+);/gi, (_, code) => {
          const n = parseInt(code, 16);
          return n > 0 && n < 0x110000 ? String.fromCodePoint(n) : "";
        });
    },
    // 去掉富文本标签，解码实体，保留后台配置的换行
    plain(text) {
      const stripped = String(text || "")
        .replace(/<script[\s\S]*?<\/script>/gi, " ")
        .replace(/<style[\s\S]*?<\/style>/gi, " ")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<\/div>/gi, "\n")
        .replace(/<\/li>/gi, "\n")
        .replace(/<\/h[1-6]>/gi, "\n")
        .replace(/<[^>]+>/g, "");
      return this.decodeEntities(stripped)
        .replace(/\r\n?/g, "\n")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n[ \t]+/g, "\n")
        .replace(/[ \t]{2,}/g, " ")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    },
    yearImage(year) {
      if (localYearImages[year]) {
        return localYearImages[year];
      }
      const num = Number(year);
      if (num >= 2009 && num <= 2022) {
        return (
          "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/memorabilia/" +
          year +
          ".png"
        );
      }
      return "";
    },
    parseTime(timeText) {
      const text = String(timeText || "");
      const matched = text.match(/(\d{4})(?:-\d{4})?年(?:(\d{1,2})月)?/);
      if (!matched) {
        return { year: "其他", month: 0, sortYear: 0 };
      }
      return {
        year: matched[1],
        month: matched[2] ? Number(matched[2]) : 0,
        sortYear: Number(matched[1]),
      };
    },
    localItems() {
      return localMemorabilia.map((item, index) => {
        const parsed = this.parseTime(item.time);
        return {
          id: "local-" + index,
          order: index,
          sort: 0,
          year: parsed.year,
          month: parsed.month,
          sortYear: parsed.sortYear,
          timeText: item.time,
          text: item.text,
        };
      });
    },
    // 后台配置约定（栏目：旷真大事记 cid=12）：
    // field_year 决定归属年份；展示内容取 content/textcontent，不取标题/描述
    cmsItems(rows) {
      return rows
        .map((item, index) => {
          const fields = item.fields || {};
          const yearRaw = String(fields.field_year || "").trim();
          let year = /^\d{4}$/.test(yearRaw) ? yearRaw : "";

          const body = this.plain(item.textcontent || item.content);
          const title = this.plain(item.title);
          const summary = this.plain(item.summary);
          // 优先正文；兼容旧数据无正文时回退标题/描述
          const text = body || summary || title;
          if (!text) return null;

          if (!year) {
            const fromText =
              text.match(/^(\d{4})年/) ||
              title.match(/^(\d{4})年/) ||
              summary.match(/^(\d{4})年/);
            if (!fromText) return null;
            year = fromText[1];
          }

          return {
            id: "cms-" + (item.id || index),
            order: index,
            sort: Number(item.sort) || 0,
            year: year,
            month: 0,
            sortYear: Number(year),
            timeText: year + "年",
            text: text,
          };
        })
        .filter((item) => item && item.text);
    },
    buildGroups(items) {
      const list = (items || []).slice();
      list.sort((a, b) => {
        if (b.sortYear !== a.sortYear) return b.sortYear - a.sortYear;
        if ((a.sort || 0) !== (b.sort || 0)) return (a.sort || 0) - (b.sort || 0);
        return a.order - b.order;
      });
      const groups = [];
      list.forEach((item) => {
        let group = null;
        for (let i = 0; i < groups.length; i++) {
          if (groups[i].year === item.year) {
            group = groups[i];
            break;
          }
        }
        if (!group) {
          group = {
            year: item.year,
            image: this.yearImage(item.year),
            items: [],
          };
          groups.push(group);
        }
        group.items.push(item);
      });
      return groups;
    },
    loadFromCms() {
      const all = [];
      const pull = (page) => {
        req("post", "api/base/articlelist", {
          Cid: "12",
          Page: page,
          Limit: 100,
        })
          .then((res) => {
            const rows = res.data || [];
            all.push.apply(all, rows);
            const total = Number(res.count) || all.length;
            if (rows.length && all.length < total && page < 30) {
              pull(page + 1);
              return;
            }
            if (all.length) {
              this.groups = this.buildGroups(this.cmsItems(all));
            }
          })
          .catch(() => {});
      };
      pull(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.memorabiliaBox {
  width: 100%;
  margin: auto;
  padding: 1rem 0;
}
.littleTip {
  display: flex;
  margin-bottom: 0.1rem;

  .timeMsg {
    flex: 4;
    text-align: left;
    color: #ab0000;
    font-weight: 700;
    padding-left: 0.5rem;
    box-sizing: border-box;
  }

  .contentMsg {
    box-sizing: border-box;
    flex: 10;
    text-align: left;
    padding-left: 0.2rem;
    padding-right: 0.5rem;

    > .contentText {
      margin-bottom: 8px;
      color: #333333;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      white-space: pre-line;
    }
  }
}
.year-label {
  padding: 0.2rem 0 0.3rem 0.5rem;
  color: #ab0000;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1;
}
.contont {
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
}
</style>
